import { render, staticRenderFns } from "./ViewCompanyComponent.vue?vue&type=template&id=2efcfa84&scoped=true"
import script from "./ViewCompanyComponent.vue?vue&type=script&lang=js"
export * from "./ViewCompanyComponent.vue?vue&type=script&lang=js"
import style0 from "./ViewCompanyComponent.vue?vue&type=style&index=0&id=2efcfa84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efcfa84",
  null
  
)

export default component.exports